import { createGlobalState } from '@vueuse/core';

export type UseContentsAssociatedMembers = {};

export type UniqContent = {
  id: string;
  memberIds: string[];
};

export type UniqContents = Map<string, UniqContent>;

export const useGlobalAssociatedMember = createGlobalState(() =>
  useNomadStorage('contents-user-associated', {}, 'family')
);

export const useContentsAssociatedMembers = () => {
  const storage = useGlobalAssociatedMember();

  const profile = useProfileStore();

  const all = computed(() => profile.contents);

  const uniqContents = computed<UniqContents>(() => {
    const uContents: UniqContents = new Map();
    all.value.forEach((content) => {
      const id = content.id;
      const memberId = content.memberId;
      if (memberId) {
        if (!uContents.get(id)) {
          uContents.set(id, {
            id,
            memberIds: [],
          });
        }
        uContents.get(id).memberIds.push(memberId);
      }
    });
    return uContents;
  });

  const hasMultipleMember = (id) => {
    const uContent = uniqContents.value.get(id);
    if (!uContent) return false;
    return uContent.memberIds.length > 1;
  };

  const getFirstContentMemberId = (contentId) => {
    return uniqContents.value.get(contentId).memberIds[0];
  };

  const isDefaultContentMemberId = (contentId, memberId) => {
    if (!hasMultipleMember(contentId)) return true;
    if (!storage.value[contentId]) {
      return getFirstContentMemberId(contentId) === memberId;
    }

    return storage.value[contentId] === memberId;
  };

  const getDefaultContentMemberId = (contentId) => {
    if (!storage.value[contentId]) {
      return getFirstContentMemberId(contentId);
    }
    return storage.value[contentId];
  };

  const saveDefaultContentMemberId = (contentId: string, memberId: string) => {
    storage.value[contentId] = memberId;
  };

  return {
    hasMultipleMember,
    isDefaultContentMemberId,
    saveDefaultContentMemberId,
    getDefaultContentMemberId,
  };
};
